// #2142 (docs/score/announcer-ui-redesign.md §4.4/§5) — band 4, the look-up
// column's pure selection logic. The column shows exactly one class, driven
// by AnnouncerContext's shared `viewingClassId` (null = "following the
// ring", set by #2140's day spine on a class-row click and read here — this
// card adds NO second pinned-class concept).
import { RIDE_STATUSES } from "score-common";
import { isResultRevealed } from "./orderOfGo.js";

// STAY PINNED (§5): the viewed class is whichever the announcer explicitly
// clicked, or the running class by default. "Following" means the column is
// currently showing whatever IS the running class right now — true both for
// the untouched null-viewingClassId default AND for an explicit click that
// happens to land back on the running row (day-spine's RUNNING row, AC10).
export function isFollowingRing(viewedClassId, liveClassId) {
  return viewedClassId === liveClassId;
}

// §5 "a dot on the button" — something landed while the announcer was away:
// the ring moved on to a different running class than the one that was
// running when they pinned away, OR that same running class's placings were
// committed while they were away. Only meaningful while NOT following (the
// dot lives on the return button, which only renders in that state).
export function computeReturnDot({
  following,
  liveClassId,
  liveClassIdWhenLeft,
  placedWhenLeft,
  placedNow,
}) {
  if (following) return false;
  if (liveClassId !== liveClassIdWhenLeft) return true;
  return Boolean(placedNow) && !placedWhenLeft;
}

// §4.4 "every ride ... with scores": not-yet-ridden shows a dash, the ride
// in the ring shows "pending", a SCRATCHED ride shows no score at all (its
// exception label carries the termReason instead, see LookupColumn.jsx's
// own rideExceptionLabel, same precedent as LiveDesk.jsx's #1838 pattern).
// A ride that has already run but whose own result isn't CONFIRMED/FINAL
// yet also reads "pending" — never leak an unrevealed score (#699).
export const RIDE_LOOKUP_KIND = {
  SCRATCHED: "SCRATCHED",
  DASH: "DASH",
  PENDING: "PENDING",
  SCORE: "SCORE",
};

export function classifyRideForLookup({ status, isCurrent, result }) {
  if (status === RIDE_STATUSES.SCRATCHED) {
    return { kind: RIDE_LOOKUP_KIND.SCRATCHED, composite: null };
  }
  if (isCurrent) {
    return { kind: RIDE_LOOKUP_KIND.PENDING, composite: null };
  }
  if (status === RIDE_STATUSES.PENDING) {
    return { kind: RIDE_LOOKUP_KIND.DASH, composite: null };
  }
  if (result && isResultRevealed(result.status)) {
    return { kind: RIDE_LOOKUP_KIND.SCORE, composite: result.composite };
  }
  return { kind: RIDE_LOOKUP_KIND.PENDING, composite: null };
}
